import TspApiService from "../../api/tspApiService";
import useTspApiResource from "../../hooks/useTspApiResource";
import { sortVisitsNewestFirst } from "./placeModel";

// Every recorded city visit (route place) of the IN_PROGRESS journeys — the
// only state book distribution can be recorded in — newest first. Reuses the
// existing journeys and city-visits APIs; nothing is stored twice.
export default function useTspBookDistributionPlaces() {
  return useTspApiResource(async () => {
    const journeys = await TspApiService.listJourneys({ status: "IN_PROGRESS", sort: "journey_name", order: "asc", limit: 100 });
    const pages = await Promise.all((journeys.data || []).map((journey) => TspApiService.listCityVisits({ journey_id: journey.id, limit: 100 })));
    return { data: sortVisitsNewestFirst(pages.flatMap((page) => page.data || [])) };
  }, []);
}
